module.exports = __webpack_public_path__ + "img/pypj_b.1a0c9cbf.png";